export default __webpack_public_path__ + "static/logo-4a5d6501e86099b55ab46cb0c1cded24.svg";